import axios from "axios";
import store from '../store/index'
import { router } from '../router/router'

//#region
//BU KISIM GLOBAL APP VUE RENDERLANDIĞI GLOBAL BİR YERE KOY
//axios.defaults.baseURL = "http://localhost:3000/"
axios.defaults.baseURL = "https://api.kihero.com.tr/";
//axios.defaults.baseURL = "https://kdviadem.com.tr/";
axios.interceptors.request.use(
  config => {
    let adminToken = store.state.loggedAdmin.token
    if (adminToken !== null) {
      config.headers['Auth'] = adminToken
    }
    return config
  },
  error => {
    // do something with request error
    console.log(JSON.stringify(error)) // for debug
    //return Promise.reject(error)
  }
)

axios.interceptors.response.use((response) => {
  //console.log(response)
  return response;
}, (error) => {
  console.log(error.response)
  let errorCode = error.response.status
  store.state.snackbarErrorObj = {
    snackbar: true,
    color: 'error',
    text: error.response.data.error[0].detail.message,
    timeout: 15000,
  }
  if (errorCode == 401 || errorCode == 403) {
    store.dispatch('changeLoginStatus', { isSuperAdmin: false, isLoggedIn: false, token: null })
    router.push('/adminlogin')
    localStorage.clear()
    return Promise.reject(error.response.data);
  }
  return Promise.reject(error);
});


export function sendRequest(type, controller, action, obj, err,headers) {
  let url = controller
  let head = "";
  switch (type) {
    case "GET":
      return axios.get(url, {
        params: obj
      }).catch(function (error) {
        if (err != undefined) {
            err(error)
        }
        errorFunc(error, '/loginPage')
      })
    case "POST":
      if (headers != undefined) {
        head = headers
      }
      return axios.post(url, obj,head).catch(function (error) {
        if (err != undefined) {
            err(error)
        }
        errorFunc(error, '/loginPage')
      });
    case "PUT":
      if (!url.includes("http")) {
        url = axios.defaults.baseURL + url
      }
      return axios({
        method: "put",
        baseURL: url,
        data: obj
      }).catch(function (error) {
        if (err != undefined) {
            err(error)
        }
        errorFunc(error, '/loginPage')
      });
  }
}

function errorFunc(error, url) {
  if (error.response != undefined && error.response.status == 403) {
    if (window.location.href.indexOf(url) < 0){
      window.location = url;
    }
    store.commit("LOADERTOUPDATE", {loaderToUpdate: false});
    store.state.loaderToUpdate = false;
    store.state.loader = false;
    store.commit("LOADER", false);
  }else if(error.response != undefined && error.response.status != 403 && error.response.status != 200){
    store.commit("LOADERTOUPDATE", {loaderToUpdate: false});
    store.state.loaderToUpdate = false;
    store.state.loader = false;
    store.commit("LOADER", false);
  }
}
//#endregion


export function deleteCompany(companyId) {
  return axios.post("companybaseddeletion",{ companyId })
}

export function getLog(id) {
  return axios.post("userlog", { id })
}

export function updateUserProp(userId, propertyName, value, companyId) {
  return axios.post("updateUserProp", { userId, propertyName, value },{ headers: { companyId } })
}

export function bannedusersList() {
  return axios.post("banneduserslist")
}

export function userblockremove(ip)
 {
  return axios.post("userblockremove", { ip })
}

export function addUser(user, companyId) {
  return axios.post("addUser", user, { headers: { companyId } })
}

export function updateAdminStatus(userId, companyId, adminStatus) {
  return axios.post("updateAdminStatus", { userId, adminStatus }, { headers: { companyId } })
}

export function updateCompanyStatus(companyId, status) {
  return axios.post("updateCompanyStatus", { status }, { headers: { companyId } })
}

export function updateUserAuth(userId, companyId, authObj) {
  return axios.post("updateUserAuth", { userId, authObj }, { headers: { companyId } })
}

export function updateCompanyInfo(updateObj) {
  return axios.post("updateCompanyInfo", { updateObj })
}

export function updateCompanyProperty(companyId, propName, value) {
  return axios.post("updateCompanyProperty", { propName, value }, { headers: { companyId } })
}
export function updateCompanyPropertyWithDeadLine(companyId, propName, value) {
  return axios.post("updateCompanyPropertyWithDeadLine", { propName, value }, { headers: { companyId } })
}

export function updateCompanySubscriptionPlan(companyId, subscriptionPlan) {
  return axios.post("updateCompanySubscriptionPlan", { subscriptionPlan }, { headers: { companyId } })
}

export function addCompany(newCompanyObj) {
  return axios.post("addCompany", newCompanyObj)
}

export function getUsersList(companyId) {
  return axios.get("getUsersList", { headers: { companyId } })
}

export function getUserLog(choice, selection, paginationObj, type, companyId, userId) {
  return axios.post("gettablesdateselection", {choice, selection, paginationObj, type, userId}, { headers: { companyId }})
}

export function getCompanyList() {
  return axios.get("getCompanyList")
}

export function getAllUserList() {
  return axios.get("getAllUserList")
}

export function addMultipleUsers(emailArray, companyId , companyName) {
  return axios.post("addMultipleUser", {emailArray , companyName}, { headers: { companyId } })
}
